import ENV from "./ENV";
// import Manifest from 'config/Manifest'
// import storageActions from 'app/utils/storageActions'
import store from "app/redux/store";
import timeHelpers from "app/utils/timeHelpers";

let textHelpers = {
  fullDateTime(date) {
    let dt = new Date(date);
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let d = days[dt.getDay()];
    let M = dt.getMonth() + 1;
    let D = dt.getDate();
    let time = textHelpers.formatTime(date);
    return `${d}, ${M}/${D} ${time}`;
  },
  formatTime(date = new Date(), short = false) {
    let dt = new Date(date);
    let hours = dt.getHours();
    let minutes = dt.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    if (short) {
      // '12:12p'
      let strTime = hours + ":" + minutes + ampm.slice(0, 1);
      return strTime;
    } else {
      // '12:12 PM'
      let strTime = hours + ":" + minutes + " " + ampm.toUpperCase();
      return strTime;
    }
  },
  formatDate(date, short = false, showDayOfWeek = true, showYear = true) {
    let dt;
    if (typeof date == "string" && date.length == 10) {
      dt = timeHelpers.dateToDateTime(date);
    } else {
      dt = new Date(date);
    }
    let months = [
      "Jan",
      "Feb",
      "Mar",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let weekDays = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
    let month = dt.getMonth();
    let dayOfWeek = dt.getDay();
    let dayOfMonth = dt.getDate();
    let year = dt.getFullYear();

    if (year != new Date().getFullYear()) showYear = true;

    if (short) {
      let seperator = "/";
      // seperator = "-";
      // `1/1/21`
      // let string = `${month+1}/${dayOfMonth}/${year.toString().slice(2,4)}`
      // let string = `${year.toString().slice(2,4)}-${month+1}-${dayOfMonth}`
      let monthZero = (month + 1).toString().length == 1 ? "0" : "";
      let dayZero = dayOfMonth.toString().length == 1 ? "0" : "";
      // let string = `${monthZero}${month+1}-${dayZero}${dayOfMonth}-${year.toString().slice(2,4)}`
      let string = `${month + 1}${seperator}${dayOfMonth}`;
      if (showYear) {
        string += `${seperator}${year.toString().slice(2, 4)}`;
      }
      if (showDayOfWeek) {
        // `Mon 1/1/21`
        string = `${weekDays[dayOfWeek]} ${string}`;
      }
      return string;
    } else {
      // `Mon, Jan 1, 2021`
      let string = `${weekDays[dayOfWeek]}, ${months[month]} ${dayOfMonth}`;
      if (showYear) {
        string += `, ${year}`;
      }
      return string;
    }
  },
  wasDoneToday(value, orCreated = false, datetime = null) {
    if (!datetime) datetime = new Date();
    let doneToday = 0;
    if (!!value && !!value.created_at && orCreated) {
      if (timeHelpers.wasToday(value.created_at)) {
        if (value.id != value.root_id) {
          doneToday++;
        }
      }
    }
    // if(!!value?.progress_at?.length){
    //   for(let progress of textHelpers.newestFirst(value.progress_at)){
    //     let wasToday = timeHelpers.wasToday(progress)
    //     if(wasToday){
    //       doneToday++
    //     }
    //     else {
    //       break
    //     }
    //   }
    // }
    if (!!value?.timeline?.length) {
      // if(value.id==235) console.log(textHelpers.doneSinceMilestone(value))
      let events = textHelpers.newestFirst(
        textHelpers.doneSinceMilestone(value),
      );
      for (let event of events) {
        let wasToday = timeHelpers.wasToday(event.timestamp, datetime);
        // if(value.id == 310) console.log(event.timestamp, datetime, wasToday)
        if (wasToday) {
          doneToday++;
        } else {
          break;
        }
      }
    }
    return doneToday;
  },
  doneSinceMilestone(value) {
    // let { progress_at=[], timeline=[], milestones_at=[0], level } = value
    // let lastMilestone = milestones_at.reduce((pre, cur) => (
    //   Date.parse(pre) > Date.parse(cur) ? pre : cur
    // ));
    // // let items = progress_at
    // let items = timeline.filter(item => item.type == 'progress' || item.type == 'child_milestone')
    // return items.filter(da => new Date(da).getTime() > new Date(lastMilestone).getTime())
    let { timeline = [] } = value;
    let doneTypes = ["progress", "child_milestone", "child_completion"];
    // let milestoneTypes = ['milestone', 'extension', 'creation']
    let milestoneTypes = ["milestone", "extension"];
    let ignoreTypes = ["creation"];
    let items = [];
    for (let item of textHelpers.newestFirst(timeline, "timestamp")) {
      if (milestoneTypes.indexOf(item.type) >= 0) {
        // break
        // this break was so that timeline progress from before the value was created would not be counted
        // but value.timeline now handles this more strategically, so do not break here
      } else if (doneTypes.indexOf(item.type) >= 0) {
        items.push(item);
      }
    }
    items = textHelpers.oldestFirst(items, "timestamp");
    return items;
  },
  newestFirst(items = [], key = null, secondKey = null, emptyToBack = false) {
    return [...items].sort((a, b) => {
      let compA = !!key && a[key];
      if (!compA && compA !== 0) compA = !!secondKey && a[secondKey];
      if (!compA && compA !== 0) compA = a;
      let compB = !!key && b[key];
      if (!compB && compB !== 0) compB = !!secondKey && b[secondKey];
      if (!compB && compB !== 0) compB = b;

      if (!!key && (!!a[key] || a[key] === 0) && (!!b[key] || b[key] == 0)) {
        if (compA == compB) {
          // tie breaker
          // if(secondKey && (a[secondKey] || a[secondKey] === 0)) compA = a[secondKey]
          if (secondKey && (b[secondKey] || b[secondKey] === 0))
            compB = b[secondKey];
          compA = (secondKey && a[secondKey]) || a;
          compB = (secondKey && b[secondKey]) || b;
        }
      }

      if ((!compA && compA !== 0) || typeof compA == "object") {
        // console.log('no compA', key, a.value?.text)
        return 1;
      } else if ((!compB && compB !== 0) || typeof compB == "object") {
        // console.log('no compB', key, b.value?.text)
        return -1;
      }
      return compA < compB ? 1 : -1;
    });
  },
  oldestFirst(items = [], key = null, secondKey = null, inspect = false) {
    if (inspect) console.log([...items]);
    let sorted = [...items].sort((a, b) => {
      let compA = !!key && a[key];
      if (!compA && compA !== 0) compA = !!secondKey && a[secondKey];
      if (!compA && compA !== 0) compA = a;
      let compB = !!key && b[key];
      if (!compB && compB !== 0) compB = !!secondKey && b[secondKey];
      if (!compB && compB !== 0) compB = b;
      if (
        !!key &&
        (!!a[key] || a[key] === 0) &&
        (!!b[key] || b[key] == 0) &&
        compA == compB
      ) {
        // tie breaker
        compA = (secondKey && a[secondKey]) || a;
        compB = (secondKey && b[secondKey]) || b;
      }
      return compA > compB ? 1 : -1;
    });
    if (inspect) console.log([...sorted]);
    return sorted;
  },
  suggestions(query = "", values = [], excludeIds = []) {
    query = query.trim().toLowerCase();
    if (query == "") return [];
    return values
      .filter((value) => {
        if (
          value.title?.toLowerCase().includes(query) ||
          value.text?.toLowerCase().includes(query) ||
          value.id == query
        ) {
          if (!excludeIds.includes(value.id)) {
            return true;
          }
        }
        return false;
      })
      .sort((a, b) => {
        const scoreOf = (v) => {
          const t = (v.title || "").toLowerCase();
          let tier;
          if (t === query) tier = 0;
          else if (t.startsWith(query)) tier = 1;
          else if (t.includes(query)) tier = 2;
          else tier = 3; // text-only match
          // Blend recency into the tier: a value untouched for 60+ days gets up to +0.9
          // added to its tier, allowing a recently-used lower tier to overtake a stale higher one.
          const msPerDay = 86400000;
          const daysSince = v.updated_at
            ? (Date.now() - new Date(v.updated_at).getTime()) / msPerDay
            : 9999;
          // Recency strongly favors recently-used values: a value touched within 7 days
          // gets near-zero penalty; one untouched for 7+ days can lose a full tier to a
          // recently-used result. Cap at 1.5 so very stale tier-1 can lose to fresh tier-2.
          const recencyPenalty = tier > 0 ? Math.min(1.5, daysSince / 7) : 0;
          return tier + recencyPenalty;
        };
        return scoreOf(a) - scoreOf(b);
      });
  },
  determineLevel(value, values, fromBottom = true) {
    if (typeof value.id == "string" && value.id.includes("ftue"))
      return value.level;
    let nextGenKey = fromBottom ? "child_ids" : "parent_ids";
    // return value.level
    let level = 0;
    let prevIds = [];
    let nextGenIds = value[nextGenKey];
    let nextGen = values.filter((v) => nextGenIds?.includes(v.id));
    while (nextGen.length > 0) {
      level += 1;
      nextGenIds = nextGen.reduce(
        (ids, v) => [...ids, ...v[nextGenKey].filter((id) => id != value.id)],
        [],
      );
      nextGenIds = [...new Set(nextGenIds)];
      // nextGen = values.filter(v => nextGenIds?.includes(v.id) && !prevIds.includes(v.id))
      // prevIds = [...prevIds, ...nextGenIds]
      nextGen = values.filter((v) => nextGenIds?.includes(v.id));
    }
    return level;
  },
  getFamilyIds(
    value,
    values,
    filterKey = "",
    filterVal = null,
    direction = "both",
  ) {
    let familyIds = [value.id];

    if (direction == "both" || direction == "down") {
      let parentIds =
        value.parent_ids ||
        (!!value.parents && value.parents.map((v) => v.id)) ||
        [];
      while (parentIds.length) {
        familyIds = [...familyIds, ...parentIds];
        let parents = values.filter((v) => parentIds.includes(v.id));
        parentIds = parents.map((v) => v.parent_ids).flat();
        // if(CONSTELATE)
        //   parents.forEach(val => lines = [...lines, ...this.constelate(val, true)])
      }
    }

    // if(CONSTELATE)
    //   lines = [...lines, ...this.constelate(value, false)]

    if (direction == "both" || direction == "up") {
      let childIds =
        value.child_ids ||
        (!!value.children && value.children.map((c) => c.id)) ||
        [];
      while (childIds.length) {
        familyIds = [...familyIds, ...childIds];
        let children = values.filter((v) => childIds.includes(v.id));
        childIds = children.map((v) => v.child_ids).flat();
        // if(CONSTELATE)
        //   children.forEach(val => lines = [...lines, ...this.constelate(val, false)])
      }
    }

    if (filterKey && filterVal) {
      console.log(familyIds);
      console.log(values);
      let filteredValues = values.filter(
        (v) => familyIds.includes(v.id) && v[filterKey] == filterVal,
      );
      familyIds = filteredValues.map((v) => v.id);
      console.log(familyIds);
    }

    familyIds = [...new Set(familyIds)];
    return familyIds;
  },
  uniq(array = [], key = null, sortBy = null) {
    if (!!sortBy) {
      array = textHelpers.newestFirst(array, sortBy);
    }
    if (!!key) {
      return array.filter(
        (item, i, ar) => ar.findIndex((itm) => itm[key] == item[key]) === i,
      );
    }
    return array.filter((item, i, ar) => ar.indexOf(item) === i);
  },
  intersection(first = [], second = []) {
    let s = new Set(second);
    return first.filter((item) => s.has(item));
  },
  compareObjects(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  },
  sortByIds(ids = [], data = []) {
    let sortedData = [...data];
    let order = {};
    ids.forEach((id, i) => {
      order[id] = i;
    });
    sortedData.sort((a, b) => {
      return order[a.id] - order[b.id];
    });
    return sortedData;
  },
  randomString(length = 10) {
    let r = (Math.random() + 1).toString(36).substring(0, length);
    return r;
  },
  capitalize(string = "") {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  titleCase(txt = "") {
    if (!txt) return "";
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  },
  trimWhiteSpace(string = "") {
    return string.replace(/^\s+|\s+$/g, "");
  },
  toSnakeCase(str = "") {
    return str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g,
      )
      .map((x) => x.toLowerCase())
      .join("_");
  },
  humanize(string = "") {
    return string
      .split("_")
      .map((w) => textHelpers.capitalize(w))
      .join(" ");
  },
  singular(st = "") {
    if (st.endsWith("s")) return st.slice(0, -1);
    if (st.toLowerCase() == "children") return st.slice(0, -3);
    return st;
  },
};

export default textHelpers;
